import React from 'react';
import Cookies from 'js-cookie';

import VBDropdown from "@vb-js-commons/new/vbDropdown";
import VBLoadingScreen from "@vb-js-commons/vbLoadingScreen";

import Navigation from '../components/static/Navigation';
import Footer from '../components/static/Footer';

class ForestCataloguePage extends React.Component {
    constructor() {
        super();

        this.state = {
            data: null,
            muni: null,
            loading: false
        }
    }

    fetchData(e) {
        e.preventDefault();

        const headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': Cookies.get('csrftoken')
        }

        this.setState({ loading: true })

        fetch(`/forest-catalogue-api/${this.state.muni}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: headers
        }).then(resp => resp.json()).then((json) => {
            this.setState({ loading: false, data: json })
        });
    }

    render() {
        return <div className="w-full flex flex-col h-screen justify-between p-0">
            <VBLoadingScreen show_loading={this.state.loading} />

            <Navigation />

            {/* HERO */}
            <div className="container bg-white">
                <div className="flex flex-wrap items-start mb-12 mt-12">
                    <div className="w-full md:w-1/2">
                        <h1 className="break-words text-start  mb-4  fs-1 n-lg-h2 ">Hitta skogsbank</h1>

                        <p className="my-6 mr-12">Hitta skogsbank höj lönsamheten i ditt skogsbruk med rätt bank. Hos bankerna finns lång erfarenhet och mycket kompetens om skog som kan hjälpa dig höja lönsamheten i ditt skogsbruk. Hitta rätt bankkontakt genom att välja kommun och klicka på ”hitta bankkontakt”</p>

                        <p className="font-medium">Frågor? <a href="tel:+468339944" className="neutral-charcoal">08-33 99 44</a></p>
                    </div>

                    <div className="w-full md:w-1/2">
                        <div className="mx-6">
                            <form onSubmit={(e) => { this.fetchData(e) }}>
                                <VBDropdown
                                    label={<label className='subtitle pb-1'>Kommun</label>}
                                    placeholder="Välj kommun"
                                    options={Window.react_data.munis}
                                    onChange={(val) => { this.setState({ muni: val.value }) }} />

                                <button type="submit" className="n-btn btn-core mt-6 w-full">Hitta bankkontakt</button>
                            </form>
                        </div>
                    </div>
                </div>

                {this.state.data && <div className="flex flex-wrap justify-center">
                    {this.state.data.map(i => {
                        return <div className="w-full md:w-1/2 xl:w-1/3 my-12">

                            <div className={`w-full relative h-full overflow-hidden bg-neutral-stone-500`} style={{ borderRadius: "32px" }}>
                                <div className="bg-white rounded-3xl my-4" style={{ width: "calc(100% - 40px)", margin: "0 auto" }}>
                                    <img className="block text-center" style={{ objectFit: "contain", height: "300px", width: "calc(100% - 40px)", margin: "0 auto" }} src={`${i.bank_logo}`} />
                                </div>

                                <div className="mx-4 pb-4 flex flex-wrap" style={{ height: "calc(100% - 320px)" }}>
                                    <div className={`w-full bg-white-50 mb-4 p-4`} style={{ borderRadius: "32px" }}>
                                        <div className="mb-4" >
                                            <p className={`mb-0 text-[13px] leading-[120%] tracking-[-0.26px] neutral-charcoal`}>{i.title ? i.title : "bank"}</p>
                                            <h4 className={`mb-0 font-bold text-[20px] leading-[120%] tracking-[-0.4px] neutral-charcoal`}>{i.title ? `${i.name && i.name} ${i.last_name && i.last_name}` : i.bank_name}</h4>
                                        </div>

                                        <div>
                                            {i.phone && <p className={`neutral-charcoal text-[13px] leading-[120%] tracking-[-0.26px] mb-0 cursor-pointer hover:underline`}><a href={`tel:${i.phone}`}>{i.phone}</a></p>}
                                            {i.email && <p className={`neutral-charcoal text-[13px] leading-[120%] tracking-[-0.26px] mb-0 cursor-pointer hover:underline`}><a href={`mailto:${i.email}`}>{i.email}</a></p>}
                                            {i.link && <p className={`neutral-charcoal text-[13px] leading-[120%] tracking-[-0.26px] mb-0 cursor-pointer hover:underline`}><a href={`${i.link}`}>Hitta kontakt hos banken</a></p>}
                                        </div>
                                    </div>
                                </div>
                            </div>



                            {/*<Card className="flex flex-wrap justify-center text-center relative bg-neutral-cloud-600 rounded-3xl h-full pb-12 mx-2">
                                <Person className="rounded-full bg-primary-main absolute overflow-hidden">
                                    {i.img ? 
                                        <img src={i.img} class="max-w-full h-auto pt-2" style={{scale: "1.3"}} />
                                            :
                                        <img src={`${Window.static_path}img/icons/${i.gender == 0 ? 'user-female.svg' : i.gender == 1 ? 'user-male.svg' : 'user.svg'}`} class="max-w-full h-auto tertiary-main-filter pt-4" style={{scale: "1.1"}} />
                                    }
                                </Person>
                        
                                {i.name || i.last_name ? <h5 className="uppercase font-bold mt-4">{i.name && i.name} {i.last_name && i.last_name}</h5>: null}
                                {i.bank_name || i.title ? <p className="grey mb-4">{i.title ? i.title : i.bank_name}</p>: null}

                                {i.bank_logo && <div><img src={i.bank_logo} className="mb-4" style={{maxWidth: "180px", maxHeight: "70px"}} /></div>}
                                {i.link && <div><a href={i.link} target="_blank" className="subtitle primary-dark hover-primary-main-filter"><img src={`${Window.static_path}img/icons/world.svg`} height="19px" className="primary-dark-filter mr-1 mb-1" />Hitta kontakt hos banken</a></div>}

                                {i.email && <div><a href={`mailto:${i.email}`} className="subtitle primary-dark hover-primary-main-filter mt-4 mb-1"><img src={`${Window.static_path}img/icons/envelope.svg`} height="19px" className="primary-dark-filter mr-1" /> {i.email}</a></div>}
                                {i.phone && <div><a href={`tel:${i.phone}`} className="subtitle primary-dark hover-primary-main-filter"><img src={`${Window.static_path}img/icons/phone.svg`} height="19px" className="primary-dark-filter mr-1 mb-1" />{i.phone}</a></div>}
                                </Card>*/}
                        </div>
                    })}
                </div>}
            </div>

            <Footer />
        </div>
    }
}

export default ForestCataloguePage;